import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: '¿Está actualizado a 2025?',
    a: 'Sí. Python 3 con conexiones a automatización y análisis de datos actuales.'
  }, {
    q: '¿Sirve si uso Java o Scratch?',
    a: 'La estructura pedagógica es transferible a cualquier lenguaje. Varios docentes lo adaptan sin problema.'
  }, {
    q: '¿Mis alumnos nunca programaron?',
    a: 'El Tomo 1 empieza desde cero absoluto. Diseñado específicamente para eso.'
  }, {
    q: '¿Funciona en mi país?',
    a: 'Sí. La Guía de Planificación incluye variantes para los calendarios escolares de Argentina, México, Colombia, Chile y Perú.'
  }];
  return <section className="py-6 md:py-8 px-4 bg-brand-cardAlt border-b border-white/5" data-id="element-50">
      <div className="max-w-2xl mx-auto" data-id="element-51">
        <h2 className="text-xl md:text-2xl font-extrabold text-center mb-5 text-white leading-tight" data-id="element-52">
          ❓ FAQ Rápido
        </h2>

        <div className="space-y-2" data-id="element-53">
          {faqs.map((faq, index) => <div key={index} className={`bg-brand-card rounded-2xl border ${openIndex === index ? 'border-brand-accent/40' : 'border-white/10'} overflow-hidden transition-all duration-200`} data-id="element-54">
              <button className="w-full px-4 py-3.5 text-left flex justify-between items-center focus:outline-none gap-3" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-55">
                <span className={`font-semibold text-sm md:text-base pr-2 ${openIndex === index ? 'text-white' : 'text-gray-200'}`} data-id="element-56">
                  {faq.q}
                </span>
                {openIndex === index ? <ChevronUp className="w-5 h-5 text-brand-accent shrink-0" data-id="element-57" /> : <ChevronDown className="w-5 h-5 text-gray-500 shrink-0" data-id="element-58" />}
              </button>
              <div className={`px-4 overflow-hidden transition-all duration-200 ease-in-out ${openIndex === index ? 'max-h-96 pb-4 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-59">
                <p className="text-xs md:text-sm text-gray-400 leading-relaxed pt-2 border-t border-white/10 font-normal" data-id="element-60">
                  {faq.a}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}